import React, {useEffect} from 'react';
// import styles from '../homepage.module.css'
import styles from './businessFirstApproach.module.css'
import {useTranslation} from "react-i18next";
import LazyText from "../../common/imagescroll/LazyText";
// import Lazy from "../../../common/lazy-scroll/Lazy";
// import {HOME_PAGE_CONTENT} from "../homePageContent";

const BusinessFirstApproach: React.FC = () => {

    const { t, i18n } = useTranslation(); // Use the translation hook

    const pageTitle = "Custom Web Development, Software & Design Solutions in Kanata - XSCI";
    const metaDescriptionContent = "XSCI specializes in custom web development, responsive design, and software solutions in Kanata. " +
        "We help businesses grow with scalable, high-performing web apps and modern digital solutions. Get started with a custom project today!";
    // Set the meta description
    let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

    // The content you're trying to use for the meta description
    const descriptionContent = metaDescriptionContent;

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.image_container}>
                    <img
                        src={"/images/about/business-no-code.jpg"}
                        className={styles.image}
                        alt="Banner background"/>
                </div>
                <div className={styles.text_content}>
                    <LazyText>

                        <h2 className={styles.section_title}>
                            We Start With the Business, Not the Code
                        </h2>
                        <p className={styles.intro_paragraph}>
                            Before writing a single line of code, we take time to understand how the business actually operates.
                            That includes how information moves, where manual work slows things down, and where systems fail to support daily activities.
                            <br></br>
                             By focusing on operations first, we can identify gaps and inefficiencies early,
                            design the right structure, and avoid building solutions that look good but don’t solve real problems.
                            This approach ensures technology is purposeful, aligned, and built on a clear foundation.
                        </p>
                    </LazyText>

                </div>

            </div>
        </section>
    );
};

export default BusinessFirstApproach;
